import { asField } from 'informed';
import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { ThemeNames } from '../../theming/ITheme.js';
import styled__default from 'styled-components';
import themes from '../../theming/themes.js';
import React, { memo, useMemo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Icon from '../Icon/index.js';
import _InputMessage from '../InputMessage/index.js';
import DateSelectContainer from './DateSelectContainer.js';
import _Label from '../Label/index.js';
import legacyParse from '../../../node_modules/@date-fns/upgrade/v2/legacyParse/index.js';
import isValid from '../../../node_modules/date-fns/esm/isValid/index.js';
import format from '../../../node_modules/date-fns/esm/format/index.js';
import getDaysInMonth from '../../../node_modules/date-fns/esm/getDaysInMonth/index.js';
import isAfter from '../../../node_modules/date-fns/esm/isAfter/index.js';
import isBefore from '../../../node_modules/date-fns/esm/isBefore/index.js';
import isWithinInterval from '../../../node_modules/date-fns/esm/isWithinInterval/index.js';
import invariant from 'invariant';
import { DATE_SELECT_TRANSLATIONS } from './Language.js';

var _excluded = ["fieldApi", "fieldState"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var StyledSelect = styled__default('select')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 12px;\n  font-size: 1rem;\n  min-width: 100%;\n  color: ", ";\n  background-color: ", ";\n  border: 2px solid;\n  border-color: ", ";\n  display: inline-block;\n  &:focus {\n    outline: none;\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n  &:focus ~ #error-message {\n    display: none;\n  }\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  &:focus ~ #error-message {\n    display: none;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.black;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.white;
}, function (_ref3) {
  var theme = _ref3.theme,
    error = _ref3.error;
  if (error) {
    return theme.palette.errorDark;
  }
  return theme.name === ThemeNames.lincoln ? theme.palette.grayLighter : theme.palette.gray;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.secondaryLighter;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.boxShadow.buttonFocus;
});
var StyledIconContainer = styled__default('span')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: ", ";\n  font-size: 0.75rem;\n  pointer-events: none;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  top: 0;\n  width: 2.66667rem;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.white;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.secondaryDark;
});
var StyledSelectContainer = styled__default('div')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: auto;\n  text-align: left;\n"])));
var StyledRelativeSelectContainer = styled__default('div')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: auto;\n  text-align: left;\n  position: relative;\n"])));
/**
 * @deprecated deprecated in favor of DatePickerV2
 */
var StyledInput = styled__default('input')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: 12px;\n  padding-left: ", ";\n  font-size: 1rem;\n  display: inline-block;\n  color: ", ";\n  border: 2px solid;\n  border-color: ", ";\n  background-color: ", ";\n  &:focus {\n    outline: none;\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n  &[disabled] {\n    opacity: 0.3;\n  }\n"])), function (_ref8) {
  var icon = _ref8.icon;
  return icon ? '2.5rem' : '12px';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.black;
}, function (_ref10) {
  var theme = _ref10.theme,
    error = _ref10.error;
  if (error) {
    return theme.palette.errorDark;
  }
  return theme.name === ThemeNames.lincoln ? theme.palette.grayLighter : theme.palette.gray;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.palette.white;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.secondaryLighter;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.boxShadow.buttonFocus;
});
var parseDateFunction = function parseDateFunction(date) {
  if (!date) {
    return legacyParse(date);
  }
  var parsedDate = new Date(date);
  var parsedDateYear = date.substr(date.lastIndexOf('/') + 1, date.length);
  return parsedDate.setFullYear(parseInt(parsedDateYear, 10));
};
var validateDate = function validateDate(required) {
  var i18n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  return function (date) {
    if (!required && (date === '//' || !date)) {
      return undefined;
    }
    var parsedDate = legacyParse(date);
    var month = date && date.split('/')[0];
    var day = date && date.split('/')[1];
    var year = date && date.split('/')[2];
    var dateEntered = !!month && !!day && !!year;
    var daysInMonth = getDaysInMonth(new Date(parseInt(year, 10), parseInt(month, 10) - 1));
    var isMonthInvalid = daysInMonth < parseInt(day, 10);
    return !isValid(parsedDate) || !dateEntered || isMonthInvalid ? DATE_SELECT_TRANSLATIONS[i18n].invalidDate : undefined;
  };
};
var validateAfter = function validateAfter(required, after) {
  var i18n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-US';
  return function (date) {
    if (!required && (date === '//' || !date)) {
      return undefined;
    }
    var validatedYear = date && date.length < 10;
    var afterDate = legacyParse(after);
    var parsedDate = parseDateFunction(date);
    if (validatedYear) {
      return DATE_SELECT_TRANSLATIONS[i18n].invalidDate;
    }
    var isValidDate = validateDate(required, i18n)(date);
    return isValidDate ? isValidDate : !isAfter(parsedDate, afterDate) ? DATE_SELECT_TRANSLATIONS[i18n].invalidDateAfter(after) : undefined;
  };
};
var validateBefore = function validateBefore(required, before) {
  var i18n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-US';
  return function (date) {
    if (!required && (date === '//' || !date)) {
      return undefined;
    }
    var validatedYear = date && date.length < 10;
    var beforeDate = legacyParse(before);
    var parsedDate = parseDateFunction(date);
    if (validatedYear) {
      return DATE_SELECT_TRANSLATIONS[i18n].invalidDate;
    }
    var isValidDate = validateDate(required, i18n)(date);
    return isValidDate ? isValidDate : !isBefore(parsedDate, beforeDate) ? DATE_SELECT_TRANSLATIONS[i18n].invalidDateBefore(before) : undefined;
  };
};
var validateBetween = function validateBetween(required, values) {
  var i18n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-US';
  return function (date) {
    if (!required && (date === '//' || !date)) {
      return undefined;
    }
    var validatedYear = date && date.length < 10;
    var startDate = legacyParse(values[0]);
    var endDate = legacyParse(values[1]);
    var parsedDate = parseDateFunction(date);
    if (validatedYear) {
      return DATE_SELECT_TRANSLATIONS[i18n].invalidDate;
    }
    var isValidDate = validateDate(required, i18n)(date);
    return isValidDate ? isValidDate : !isWithinInterval(parsedDate, {
      start: startDate,
      end: endDate
    }) ? DATE_SELECT_TRANSLATIONS[i18n].invalidDateBetween(values[0], values[1]) : undefined;
  };
};
var validateBeforeToday = function validateBeforeToday(required) {
  var i18n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  return validateBefore(required, format(Date.now(), 'MM/dd/yyyy'), i18n);
};
var validateAfterToday = function validateAfterToday(required) {
  var i18n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  return validateAfter(required, format(Date.now(), 'MM/dd/yyyy'), i18n);
};
var _DateSelect = asField(function (_ref14) {
  var fieldApi = _ref14.fieldApi,
    fieldState = _ref14.fieldState,
    props = _objectWithoutProperties(_ref14, _excluded);
  var error = fieldState.error,
    value = fieldState.value;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched;
  var ariaLabelText = props.ariaLabelText,
    field = props.field,
    hideLabel = props.hideLabel,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? themes["default"] : _props$theme,
    label = props.label,
    _props$i18n = props.i18n,
    i18n = _props$i18n === void 0 ? 'en-US' : _props$i18n,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$language = props.language,
    language = _props$language === void 0 ? 'en' : _props$language;
  // @ts-ignore
  var dataTestId = props['data-testid'];
  var _split = (value || '//').split('/'),
    _split2 = _slicedToArray(_split, 3),
    month = _split2[0],
    day = _split2[1],
    year = _split2[2];
  var updateValue = function updateValue(newVal) {
    if (newVal === '//') {
      setValue('');
    } else {
      setValue(newVal);
    }
  };
  var handleDay = function handleDay(e) {
    var newDay = e.target.value.replace(/[^\d]/g, '');
    var newDate = "".concat(month, "/").concat(newDay, "/").concat(year);
    updateValue(newDate);
  };
  var handleMonth = function handleMonth(e) {
    var newMonth = e.target.value;
    var newDate = "".concat(newMonth, "/").concat(day, "/").concat(year);
    updateValue(newMonth !== '00' ? newDate : "/".concat(day, "/").concat(year));
  };
  var handleYear = function handleYear(e) {
    var newYear = e.target.value.replace(/[^\d]/g, '');
    var newDate = "".concat(month, "/").concat(day, "/").concat(newYear);
    updateValue(newDate);
  };
  var stringifiedLabel = function stringifiedLabel() {
    if (typeof label === 'string') {
      return label;
    } else {
      return ariaLabelText;
    }
  };
  invariant(typeof label === 'string' || typeof label !== 'string' && !!ariaLabelText, 'You must provide ariaLabelText when using a jsx label');
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hideLabel ? /*#__PURE__*/React.createElement(_Label, {
    theme: theme,
    "data-testid": 'styled-label',
    htmlFor: field,
    language: language
  }, label) : null, /*#__PURE__*/React.createElement(DateSelectContainer, {
    "aria-label": hideLabel ? stringifiedLabel() : undefined,
    id: field
  }, /*#__PURE__*/React.createElement(StyledSelectContainer, null, /*#__PURE__*/React.createElement(StyledRelativeSelectContainer, null, /*#__PURE__*/React.createElement(StyledSelect, {
    theme: theme,
    onChange: handleMonth,
    name: "month",
    "aria-label": "Month",
    error: error,
    value: month || '00',
    "data-testid": dataTestId + '-month'
  }, /*#__PURE__*/React.createElement("option", {
    value: '00',
    disabled: required
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption00), /*#__PURE__*/React.createElement("option", {
    value: "01"
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption01), /*#__PURE__*/React.createElement("option", {
    value: "02"
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption02), /*#__PURE__*/React.createElement("option", {
    value: "03"
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption03), /*#__PURE__*/React.createElement("option", {
    value: "04"
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption04), /*#__PURE__*/React.createElement("option", {
    value: "05"
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption05), /*#__PURE__*/React.createElement("option", {
    value: "06"
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption06), /*#__PURE__*/React.createElement("option", {
    value: "07"
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption07), /*#__PURE__*/React.createElement("option", {
    value: "08"
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption08), /*#__PURE__*/React.createElement("option", {
    value: "09"
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption09), /*#__PURE__*/React.createElement("option", {
    value: "10"
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption10), /*#__PURE__*/React.createElement("option", {
    value: "11"
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption11), /*#__PURE__*/React.createElement("option", {
    value: "12"
  }, DATE_SELECT_TRANSLATIONS[i18n].monthOption12)), /*#__PURE__*/React.createElement(StyledIconContainer, {
    theme: theme
  }, /*#__PURE__*/React.createElement(_Icon, {
    color: "white",
    name: "caret-down"
  })))), /*#__PURE__*/React.createElement(StyledInput, {
    maxLength: 2,
    className: "ml-2",
    style: {
      width: '3.125rem'
    },
    value: day,
    placeholder: "DD",
    "aria-label": "Day",
    theme: theme,
    onChange: handleDay,
    type: "text",
    name: "day",
    error: error,
    "data-testid": dataTestId + '-day'
  }), /*#__PURE__*/React.createElement(StyledInput, {
    maxLength: 4,
    className: "ml-2",
    style: {
      width: '4.7rem'
    },
    value: year,
    placeholder: language === 'en' ? 'YYYY' : 'AAAA',
    theme: theme,
    "aria-label": "Year",
    onChange: handleYear,
    type: "text",
    name: "year",
    error: error,
    "data-testid": dataTestId + '-year'
  })), error && /*#__PURE__*/React.createElement(_InputMessage, {
    error: true,
    id: 'error-message'
  }, error));
});
var DateSelect = function DateSelect(props) {
  var after = props.after,
    afterToday = props.afterToday,
    before = props.before,
    beforeToday = props.beforeToday,
    between = props.between,
    _props$i18n2 = props.i18n,
    i18n = _props$i18n2 === void 0 ? 'en-US' : _props$i18n2,
    _props$required2 = props.required,
    required = _props$required2 === void 0 ? false : _props$required2;
  var validatorFunction = useMemo(function () {
    var func = validateDate(required, i18n);
    if (!!after) {
      func = validateAfter(required, after, i18n);
    }
    if (!!before) {
      func = validateBefore(required, before, i18n);
    }
    if (!!between) {
      func = validateBetween(required, between);
    }
    if (!!afterToday) {
      func = validateAfterToday(required, i18n);
    }
    if (!!beforeToday) {
      func = validateBeforeToday(required, i18n);
    }
    return func;
  }, [required, after, before, between, i18n]);
  return /*#__PURE__*/React.createElement(_DateSelect, _extends({}, props, {
    validate: validatorFunction
  }));
};
var _DateSelect$1 = withDefaultTheme(/*#__PURE__*/memo(DateSelect));

export default _DateSelect$1;
